import { Link } from "react-router-dom";
import { LGoButton } from "@/ui/branded";

export const tradingPendingBadge = "Zákazníci ji zatím nevidí";

/** The gate from lastgo-api ADR 0004 as it applies to authoring: nothing an
 *  unverified partner writes can be bought, but writing it is how the portal is
 *  ready the minute Stripe answers — so the screen explains instead of closing. */
export function TradingPendingNotice() {
  return (
    <div className="rounded-xl border border-dashed border-border px-6 py-5 space-y-3">
      <h2 className="font-display text-xl font-semibold tracking-tight">
        Účet zatím není ověřený.
      </h2>
      <p className="text-muted-foreground max-w-prose">
        Slevové termíny si můžete připravit, zákazníci je ale uvidí až po dokončení ověření.
      </p>
      <LGoButton asChild variant="secondary">
        <Link to="/settings">Přejít do nastavení</Link>
      </LGoButton>
    </div>
  );
}

/** Shown when the payment-account request itself failed — distinct from
 *  `TradingPendingNotice` because a failed request has not told us the
 *  account cannot trade, only that we do not know either way yet. */
export function TradingStatusUnknownNotice({ onRetry }: { onRetry?: () => void }) {
  return (
    <div className="rounded-xl border border-dashed border-border px-6 py-5 space-y-3">
      <h2 className="font-display text-xl font-semibold tracking-tight">
        Stav ověření se teď nepodařilo zjistit.
      </h2>
      <p className="text-muted-foreground max-w-prose">
        Zkuste to prosím znovu — zatím nevíme, jak na tom účet je.
      </p>
      {onRetry && (
        <LGoButton variant="secondary" onClick={onRetry}>
          Zkusit znovu
        </LGoButton>
      )}
    </div>
  );
}
